<template>
    <section v-if="props.modelValue" class="modal">
        <article class="modal__content">
            <h4 class="modal__title">Agregar Usuario</h4>
            <form class="modal__form">
                <div class="modal__group">
                    <label for="empleado">Nombre del empleado</label>
                    <input id="empleado" type="text" class="modal__input" required />
                </div>
                <div class="block-module">
                    <h5 class="module-title">Módulos</h5>
                    <div class="container-list">
                        <ul class="module-list">
                            <li><label><input type="checkbox" name="modules" value="m_1"> Modulo 1 </label></li>
                            <li><label><input type="checkbox" name="modules" value="m_2"> Modulo 2</label></li>
                        </ul>
                    </div>
                </div>
                <div class="block-module">
                    <h5 class="module-title">Permisos</h5>
                    <div class="container-list">
                        <ul class="module-list">
                            <li><label><input type="checkbox" name="permission" value="p_1"> Permiso 1 </label></li>
                            <li><label><input type="checkbox" name="permission" value="p_2"> Permiso 2</label></li>
                        </ul>
                    </div>
                </div>
                <div class="modal__separator">
                    <button type="submit" class="save-button">Guardar</button>
                </div>
            </form>
            <button class="modal__close" @click="closeModal">&times;</button>
        </article>
    </section>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    modelValue: Boolean
});
const emit = defineEmits(['update:modelValue']);

const closeModal = () => {
    emit('update:modelValue', false);
};

</script>

<style scoped>
.block-module {
    margin: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    background-color: #fff;
}

.module-title {
    /* text-align: center; */
    font-size: 14px;
    font-weight: 100;
    margin: 0;
}

.container-list {
    width: 100%;
    max-height: 60px;
    overflow-y: scroll;
}

.module-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.module-list li {
    font-size: 12px;
    background-color: #f2f2f2;
    width: 100%;
    margin: 3px 0;
    padding: 3px;
    display: flex;
    justify-content: flex-start;
}
label {
    cursor: pointer;
    text-align: left;
    width: 100%;
}

.modal__group {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-bottom: 10px;
}

.modal__group label {
  font-size: 12px;
  text-align: left;
}

.modal__group input {
  height: 39px;
  border: solid 1px #e5e5e5;
  padding: 15px;
  color: #c6c6c6;
  border-radius: 15px;
}
</style>